import { formatMoney } from '../components/utilities';

const Shipping = {
  submit: function (_$form) {
    var shippingBox = $('[data-shipping-calculator]'),
      formShipping = shippingBox.find('form'),
      inputValue = shippingBox.find('[name=cep]'),
      btnSubmit = shippingBox.find('[type=submit]'),
      printResults = shippingBox.find('[data-list-shipping]'),
      zipcode = '';
  
    inputValue.on('input', function(e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,5})(\d{0,3})/);
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2];
    });
    
    formShipping.on('submit', function(e) {
      e.preventDefault();
    
      var sku = $('[data-box-produto]').find('input[name="sku"]').val(),
      quantity = $('[data-box-produto]').find('[name=quantity]').val(),
      zipcode = inputValue.val();
      
      zipcode = zipcode.replace('-', '');
      
      if (zipcode.length == 8) {
        //console.log('sku:', '"' + sku + '"', typeof sku, 'quantidade:', quantity, 'cep:', zipcode)
        
        $.ajax({
          url: '/frete_produto',
          cache: false,
          type: 'POST',
          dataType: 'json',
          data: {
            sku: sku,
            zip: zipcode,
            quantity: quantity
          },
          beforeSend: function() {
            btnSubmit.html('Calculando...')
          },
        })
        .done(function (resp) {
          console.log(resp)
          
          var methods = JSON.parse(resp.methods),
          result = '<ul>';
          
          methods.forEach(function(method){
            //console.log(method)
            var price = method.price,
            days = method.delivery_days;
            
            price = price == 0 ? 'Grátis' : formatMoney(price);

            result += `
              <li>
                <span class="method">${method.name}</span>
                <span class="price">${price}</span>
                <p class="shipping-time">${method.description}</p>
              </li>
            `
          })
          
          result += '</ul>';
          
          printResults.html(result)
          //console.log(methods, address)
        })
        .fail(function (error) {
          console.info('Ocorreu um erro')
          printResults.html('<div class="content"><p>Ocorreu um erro</p></div>');
        })
        .always(function(){
          btnSubmit.html('Calcular');
        })
      } else {
        printResults.html('<div class="content"><p>Formato de CEP inválido</p></div>');
      }
    })
  },
  init: function() {
    Shipping.submit();
  }
}

export default Shipping;
